<template>
  <div class="task-detail-view">
    <div class="header-area flex items-center p-4 justify-between">
      <div class="flex items-center">
        <feather-icon
          :icon="taskCategoryIcon"
          svgClasses="h-5 w-5"
          class="mr-2"
        />
        <span class="font-semibold">{{ categoryName }}</span>
      </div>

      <div class="flex">
        <feather-icon
          class="
            action-button-icon
            rounded
            cursor-pointer
            flex
            items-center
            p-1
          "
          svgClasses="h-5 w-5"
          icon="XIcon"
          @click.stop="toggleCloseButton()"
        ></feather-icon>
      </div>
    </div>

    <div class="content-area p-4">
      <div class="content-title-label mb-5">
        <span>タスク情報</span>
      </div>
      <div class="content-text-area">
        <span>ファイル名</span>
        <span class="text-right">{{ name }}</span>
      </div>
      <div class="content-text-area">
        <span>種類</span>
        <span>{{ contentType }}</span>
      </div>
      <div class="content-text-area">
        <span>サイズ</span>
        <span>{{ size }}</span>
      </div>
      <div class="content-text-area">
        <span>タスク開始日時</span>
        <span>{{ created }}</span>
      </div>
      <div class="content-text-area">
        <span>タスク完了日時</span>
        <span>{{ updated }}</span>
      </div>
      <div class="content-text-area">
        <span>公開期限</span>
        <span>{{ expired }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin, DocumentMixin, TaskManagerMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
import { UnitUtil } from "@/utils";
import moment from "moment";

const {
  mapState, mapMutations
} = createNamespacedHelpers("enterpriseBackgroundTaskManager");


export default {
  mixins: [ColorMixin, DocumentMixin, TaskManagerMixin],
  data () {
    return {
    }
  },
  computed: {
    ...mapState(["selectedTask"]),
    task () {
      return this.selectedTask
    },
    category () {
      if(!this.task) return;
      return this.getCategoryItems(this.task.type)
    },
    categoryName () {
      if (!this.category) return ""
      return this.category.name;
    },
    taskCategoryIcon () {
      if (!this.category) return ""
      return this.category.icon;
    },
    name () {
      if (!this.task) return ""
      return this.task.name
    },
    contentType () {
      if (!this.task || !this.task.contentType) return ""
      return this.getDocumentMimeName(this.task.contentType)
    },
    size () {
      if (!this.task || !this.task.bytes) return "";
      return UnitUtil.formatBytes(this.task.bytes, 0)
    },
    updated () {
      if (!this.task) return ""
      return moment(this.task.updated_at).format("YYYY-MM-DD kk:mm")
    },
    created () {
      if (!this.task) return ""
      return moment(this.task.created_at).format("YYYY-MM-DD kk:mm")
    },
    expired () {
      if (!this.task) return ""
      return moment(this.task.expired_at).format("YYYY-MM-DD kk:mm")
    },
  },
  methods: {
    ...mapMutations(["SET_DETAIL_SIDEBAR_ACTIVE", "SET_SELECTED_TASK"]),
    toggleCloseButton () {
      this.SET_SELECTED_TASK({});
      this.SET_DETAIL_SIDEBAR_ACTIVE(false)
    },
  },
  destroyed () {
  }
}
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/vuexy/variables";

.task-detail-view {
  .header-area {
    background: $aisea-white;
    color: $aisea-gray;
  }

  .content-title-label {
    font-size: 16px;
    font-weight: 600;
  }

  .content-text-area {
    color: $aisea-gray;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .action-button-icon:hover {
    background: $aisea-light-gray;
  }
}
</style>